import React from 'react'
import "./footer.css";
import Button from '@mui/material/Button';
import { Footer } from '../data/Data';
function footer() {
    return (
        <section className="paddings footerSection">
            <div className="leftSide">
                <img src="../../../public/images/logo-light.png" alt="" />
                <h1 className='xl:text-4xl text-xl text-white font-semibold'>Do You Need Help With Anything?</h1>
                <p className='secondaryText'>Receive updates, hot deals, tutorials, discounts sent straignt in your inbox every month

                </p>
                <div className="inputContainer">
                    <input type="email" placeholder='enter your email' />
                    <Button variant='contained'>subscribe</Button>
                </div>
            </div>
            <div className="rigthSide">
                {Footer.map((item, index) => (
                    <div className='onlyChoice' key={index}>
                        <h1 className='xl:text-2xl text-lg text-white font-semibold'>{item.title}</h1>
                        <span className="secondaryText cursor-pointer">{item.text[0].list}</span>
                        <span className="secondaryText cursor-pointer">{item.text[1].list}</span>
                        <span className="secondaryText cursor-pointer">{item.text[2].list}</span>
                        <span className="secondaryText cursor-pointer">{item.text[3].list}</span>
                        <span className="secondaryText cursor-pointer">{item.text[4].list}</span>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default footer
